import { IApplicationState } from '../../types/redux';
import { selectUser } from './selectUser';

export const selectUserPhone = (state: IApplicationState) => {
  const user = selectUser(state);
  const phone = user?.phone;

  return phone ?? null;
};
